import type { AnalyticsSender } from '@funtech-int/yango-shared';

import {
    familyInviteButtonNavigated,
    FamilyInviteButtonNavigatedOn,
    familyInviteButtonShowed,
    FamilyInviteButtonShowedOn,
} from '@kinopoisk-int/evgen-web-events/web/family_invite_button';
import { familyInviteScreenDenied } from '@kinopoisk-int/evgen-web-events/web/family_invite_screen';
import { MyPageUuidType } from '@kinopoisk-int/evgen-web-events/web/named_enums';
import {
    profileAskNoMore,
    profileMovieImpressionShowed,
    profileProfileSelectedV3,
    ProfileProfileSelectedV3From,
    profileShowedV2,
} from '@kinopoisk-int/evgen-web-events/web/profile';

interface ProfileSelectedProps {
    autoShowed: boolean;
    isPreGenerated: boolean;
    hasChildAnimation: boolean;
    isFamilyAccount: boolean;
    isAuthorized: boolean;
    targetProfileId: string;
    isTargetMaster: boolean;
}

interface ProfilesAnalyticsEvents {
    inviteClicked(): void;
    inviteShowed(): void;
    profileSelected(props: ProfileSelectedProps): void;
    familyInviteScreenDeniedShowed(): void;
    showed(autoShowed: boolean): void;
    movieImpressionShowed(uuid: string): void;
    askNoMore(): void;
}

export const createAnalyticsEvents = (eventSender: AnalyticsSender): ProfilesAnalyticsEvents => ({
    inviteClicked() {
        eventSender.send(familyInviteButtonNavigated, {
            on: FamilyInviteButtonNavigatedOn.ProfileScreen,
        });
    },

    inviteShowed() {
        eventSender.sendOnce(familyInviteButtonShowed, {
            on: FamilyInviteButtonShowedOn.ProfileScreen,
        });
    },

    profileSelected(props: ProfileSelectedProps) {
        eventSender.send(profileProfileSelectedV3, {
            ...props,
            from: ProfileProfileSelectedV3From.ProfileScreen,
        });
    },

    familyInviteScreenDeniedShowed() {
        eventSender.sendOnce(familyInviteScreenDenied, {});
    },

    showed(autoShowed: boolean) {
        eventSender.sendOnce(profileShowedV2, {
            autoShowed,
            hasChildAnimation: false,
            hasChildProfile: false,
            isPreGenerated: true,
        });
    },

    movieImpressionShowed(uuid: string) {
        eventSender.sendOnce(profileMovieImpressionShowed, {
            uuid,
            uuidType: MyPageUuidType.Ott,
        });
    },

    askNoMore() {
        eventSender.send(profileAskNoMore, {});
    },
});
